import DatePickPanel from './date-picker-com/panel-date-pick.vue'
import DateRangePickPanel from './date-picker-com/panel-date-range.vue'
import MonthRangePickPanel from './date-picker-com/panel-month-range.vue'
import QuarterRangePickPanel from './date-picker-com/panel-quarter-range.vue'
import type { IDatePickerType } from './date-picker.type'

export const getPanel = function (type: IDatePickerType): any {
  switch (type) {
    case 'daterange':
    case 'datetimerange': {
      return DateRangePickPanel
    }
    case 'monthrange': {
      return MonthRangePickPanel
    }
    case 'quarterrange': {
      return QuarterRangePickPanel
    }
    default: {
      return DatePickPanel
    }
  }
}
